import React, {
  useState, useEffect, useRef, useCallback,
} from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';
import clsx from 'clsx';
import { ModalOnExitWhoCostModal } from '../organisms/ModalOnExitWhoCost';
import SpecialistContactYouModal from '../molecules/SpecialistContactYouModal';
import { addTagFirebaseAnalytcs, tagsAnalytcs } from '../../analytcs/firebase';

const MODAL_SEEN_KEY = 'modalExitWhoCostSeen';
let globalModalTriggered = false;
const TopNavLink = ({
  label, to, backgroundColor, textColor, isNew, color, newTab,
}) => {
  const currentRoute = useLocation().pathname;
  const isCurrentPage = currentRoute.includes(to);
  const [showExitModal, setShowExitModal] = useState(false);
  const [modalContactYouIsOpen, setModalContactYouIsOpen] = useState(false);

  const modalTriggered = useRef(false);

  const isMobile = useCallback(() => /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent), []);

  useEffect(() => {
    if (window.location.pathname === '/quanto-custa/'
        && !sessionStorage.getItem(MODAL_SEEN_KEY)
        && !isMobile()
        && !globalModalTriggered) {
      const handleMouseLeave = (e) => {
        if ((e.clientY <= 0 || e.clientX <= 0
            || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight)
            && !modalTriggered.current && !globalModalTriggered) {
          modalTriggered.current = true;
          globalModalTriggered = true;
          setShowExitModal(true);
          sessionStorage.setItem(MODAL_SEEN_KEY, 'true');
          window.removeEventListener('mouseout', handleMouseLeave);
        }
      };

      window.addEventListener('mouseout', handleMouseLeave);
      return () => {
        window.removeEventListener('mouseout', handleMouseLeave);
      };
    }
  }, [isMobile]);

  const handleClick = (e) => {
    if (newTab) {
      window.open(to, '_blank', 'noopener,noreferrer');
      return;
    }
    window.location.href = to;
  };

  const handleModalClose = (confirmed) => {
    setShowExitModal(false);
    if (confirmed) {
    }
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      borderRadius: '20px',
      textDecoration: 'none',
      padding: '6px 20px 10px',
      color: color || theme.palette.midGrey.main,
      transition: '0.2s',
      '& span': { fontSize: '12px' },
      '&:hover': {
        cursor: 'pointer',
        color: textColor,
        backgroundColor,
        transition: '0.1s',
      },
    },
    currentPage: { color: textColor },
    isNew: {
      backgroundColor: '#FFEEDD',
      color: theme.palette.secondary.main,
      padding: '5px 10px',
      borderRadius: '50px',
      fontWeight: 'bold',
      marginLeft: '1%',
    },
  }));

  const classes = useStyles();

  return (
    <>
      <span
        onClick={handleClick}
        className={clsx(classes.root, isCurrentPage ? classes.currentPage : '')}
        style={{ cursor: 'pointer' }}
      >
        <Typography variant="button">{label}</Typography>
        {isNew ? <Typography variant="caption" className={classes.isNew}>novo</Typography> : null}
      </span>
      {showExitModal && (
        <ModalOnExitWhoCostModal
          modalOpen={showExitModal}
          handleModalClose={handleModalClose}
          setModalContactYouIsOpen={setModalContactYouIsOpen}
          setModalOpen={setShowExitModal}
          tagPhone={addTagFirebaseAnalytcs(tagsAnalytcs.btn_saida_quanto_wpp)}
          tagWpp={addTagFirebaseAnalytcs(tagsAnalytcs.btn_saida_quanto_ligar)}
          tagPhoneId="btn_saida_quanto_wpp"
          tagWppId="btn_saida_quanto_ligar"
        />
      )}
      <SpecialistContactYouModal
        handleClose={() => setModalContactYouIsOpen(false)}
        handleConfirm={() => {}}
        isOpen={modalContactYouIsOpen}
      />
    </>
  );
};

TopNavLink.propTypes = {
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
  // Sem isso, todo link continua com o comportamento antigo (window.location.href),
  // que substitui a pagina atual. So os que precisarem de aba nova passam true.
  newTab: PropTypes.bool,
};

TopNavLink.defaultProps = {
  newTab: false,
};

export default TopNavLink;
